export default __webpack_public_path__ + "static/surgical_boom_w.912d6549efbf57a37c711fe8167faeca.svg";